define('util/keyCode',[], function () {
    'use strict';

    /**
     * A mapping of key code descriptions to their numeric values.
     */
    var keyCode = {
        ALT       : 18,
        BACKSPACE : 8,
        CTRL      : 17,
        COMMA     : 188,
        DASH      : 189,
        DELETE    : 46,
        END       : 35,
        ENTER     : 13,
        ESCAPE    : 27,
        HOME      : 36,
        PAGE_DOWN : 34,
        PAGE_UP   : 33,
        PERIOD    : 190,
        SHIFT     : 16,
        SPACE     : 32,
        TAB       : 9,
        INSERT    : 45,
        LEFT_WINDOW_KEY: 91,
        SELECT    : 93,
        F1        : 112,
        SCROLL_LOCK    : 145,
        LEFT      : 37,
        UP        : 38,
        RIGHT     : 39,
        DOWN      : 40,

        NUM_0     : 48,
        NUM_1     : 49,
        NUM_2     : 50,
        NUM_3     : 51,
        NUM_4     : 52,
        NUM_5     : 53,
        NUM_6     : 54,
        NUM_7     : 55,
        NUM_8     : 56,
        NUM_9     : 57,

        NUM_PAD_0 : 96,
        NUM_PAD_1 : 97,
        NUM_PAD_2 : 98,
        NUM_PAD_3 : 99,
        NUM_PAD_4 : 100,
        NUM_PAD_5 : 101,
        NUM_PAD_6 : 102,
        NUM_PAD_7 : 103,
        NUM_PAD_8 : 104,
        NUM_PAD_9 : 105
    };

    keyCode.NUM_KEYS = [
        keyCode.NUM_0,
        keyCode.NUM_1,
        keyCode.NUM_2,
        keyCode.NUM_3,
        keyCode.NUM_4,
        keyCode.NUM_5,
        keyCode.NUM_6,
        keyCode.NUM_7,
        keyCode.NUM_8,
        keyCode.NUM_9
    ];

    keyCode.NUM_PAD_KEYS = [
        keyCode.NUM_PAD_0,
        keyCode.NUM_PAD_1,
        keyCode.NUM_PAD_2,
        keyCode.NUM_PAD_3,
        keyCode.NUM_PAD_4,
        keyCode.NUM_PAD_5,
        keyCode.NUM_PAD_6,
        keyCode.NUM_PAD_7,
        keyCode.NUM_PAD_8,
        keyCode.NUM_PAD_9
    ];

    return keyCode;
});

